import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dashboardSearchLandmarkRealTime, reset } from '../redux/slice';

const useLandmarkData = (item, update, changesFilters, setChangesFilters) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);
  const [moreRows, setMoreRows] = useState(false);
  const [modalInformation, setModalInformation] = useState({
    open: false,
    label: "",
    data: []
  });

  const limit = 25;

  const handleChangePage = (newPage) => {
    setPage(oldState => oldState + limit);
  };

  const { landmarksToSearch, parameterOrder } = JSON.parse(item?.settings);

  useEffect(() => {
    if (changesFilters) {
      setPage(0);
      setData([]);
      setMoreRows(false);
      setChangesFilters(false);
    }
    const landmarksIds = landmarksToSearch.map(landmark => ({
      name: landmark.name,
      id: landmark.id
    }));
    dispatch(dashboardSearchLandmarkRealTime({
      landmarksIds,
      keyMemory: `${item.dashboardId}`,
      parameterOrder: `${parameterOrder}`,
      limit,
      //Temporary fix: the pagination of the tableview is rendered twice on its first load after the edit to prevent the pagination from advancing and data loss, it is validated that while in the
      // updata state the pagination does not advance.  number case P3-45566
      offset: changesFilters ? 0 : page,
      viewId: item.id
    }));
    return () => {
      dispatch(reset({ viewId: item.id }));
    };
  }, [item, update, page, changesFilters, setChangesFilters]);

  const dataLandmark = useSelector(state => state.dashboardSearchLandmarkRealTimeRedux);
  const { loadingLandmarksRealTime, landmarksRealTime } = dataLandmark[item.id] || {};
  const { items = [], total } = landmarksRealTime || {};

  useEffect(() => {
    setData((prevData) => {
      const nextData = page === 0 ? items : [...prevData, ...items];
      const reachedEndByPageSize = items.length < limit;
      const hasMoreByTotal = (total || 0) > nextData.length;
      setMoreRows(reachedEndByPageSize ? false : hasMoreByTotal);
      return nextData;
    });
  }, [items, total, page]);

  return {
    total,
    data,
    moreRows,
    loading: loadingLandmarksRealTime,
    handleChangePage,
    modalInformation,
    setModalInformation
  };
};

export default useLandmarkData;
